import React from 'react';
import GenericFeatures from '../GenericFeatures';

const FEATURES = [
  {
    name: 'Online textbook',
    icon: 'fad fa-books',
    description:
      'Our comprehensive online textbook. Easy to read, mobile-friendly, and with detailed breakdowns of sample questions. Written by an industry-leading expert with many years of experience.',
  },
  {
    name: 'Memory-tracked quiz questions',
    icon: 'fad fa-user-chart',
    description:
      "Prepare in less time with thousands of quizzes. As you study, Achievable's advanced learning engine updates a personalized model of your memory to efficiently cover all material while focusing on your trickiest topics.",
  },
  {
    name: 'Unlimited, randomized practice exams',
    icon: 'fad fa-file-certificate',
    description:
      "Simulate exam day with 25+ full-length, realistic practice exams. Specifically written with similar difficulty, wording, and weighting as the actual exam. Question text and variables are randomized to be sure you're learning the concepts instead of simply recalling answers.",
  },
  {
    name: 'A full year of access',
    icon: 'fad fa-calendar-check',
    description:
      "You'll have plenty of time to prepare. And if life gets in the way, just let us know. We're people too and we understand.",
  },
  {
    name: 'Amazing customer support',
    icon: 'fad fa-users',
    description:
      "You've probably already noticed that our site is filled with various ways to talk with us. We want to hear from you!",
  },
];

const DefaultFeatures = () => <GenericFeatures features={FEATURES} />;

export default DefaultFeatures;
